var SEND_EVENT = 'ga.event';
var PAGEVIEW = 'ga.pageView';

/**
 * Analytics module
 */
var AnalyticsModule = function(options) {

    var _defaults = {}

    var _this = this;

    _this.dataLayer = window.dataLayer;
    _this.log = window.MyAngelcam.Log;
    _this.options =  $.extend({}, _defaults, options || {});
    _this._init();
};

AnalyticsModule.prototype._init = function() {
    this.log.debug(this, 'Initial dataLayer values', this.dataLayer);
    this._addListeners();
}

AnalyticsModule.prototype._addListeners = function() {
    var _this = this;
    _this.log.debug(this, 'Registered event listeners');
    $(document).on('blur change click dblclick error focus focusin focusout hover keydown keypress keyup load submit', function(e) {
        var el = $(e.target);
        if (!el.attr('data-analytics-on')) {
            return;
        }

        if (el.data('analytics-on') !== e.type) {
            return;
        }

        _this.trackEvent(
            el.data('analytics-category'),
            el.data('analytics-action'),
            el.data('analytics-label'),
            el.data('analytics-value')
        );
    });
};

/**
 * Send event to Google tag manager
 * @param category
 * @param action
 * @param label
 * @param value
*/
AnalyticsModule.prototype.trackEvent = function (category, action, label, value, non_interaction) {
    var _this = this;
    var properties = {
        'eventCategory': category,
        'eventAction': action
    };
    if (label) {
        properties['eventLabel'] = label;
    }
    if (value) {
        properties['eventValue'] = value;
    }
    if (non_interaction) {
        properties['eventNonInteraction'] = true;
        properties['eventCallback'] = function() {
            _this.dataLayer.push({
                eventNonInteraction: false
            });
        }
    } else {
        properties['eventNonInteraction'] = false;
    }
    this.log.debug(this, SEND_EVENT, properties);
    properties['event'] = SEND_EVENT;
    this.dataLayer.push(properties);
};

/**
 * Send pageview to Google tag manager
 * @param url
 * @param title
*/
AnalyticsModule.prototype.trackPageView = function(url, title) {
    this.dataLayer.push({
      'event' : PAGEVIEW,
      'virtualPageURL' : url,
      'virtualPageTitle' : title
    });
    this.log.debug(this, PAGEVIEW, arguments);
};

AnalyticsModule.prototype.toString = function() {
    return 'Analytics';
};

export default AnalyticsModule;
